import PageHeader from "../components/layout/PageHeader";
import ContactCTA from "../components/sections/ContactCTA";

export default function Contact() {
    return (
        <div data-testid="contact-page">
            <PageHeader
                eyebrow="Get in Touch"
                title={<>Tell us about your <span className="text-blue-400">next project</span>.</>}
                description="Share a few details and our principal engineers will be in touch within one business day. No forms lost in inboxes — we promise."
            />
            <ContactCTA />
        </div>
    );
}
